<template>
  <section id="contact-wrapper">
    <div id="account-banner">
      <img src="../../../assets/img/Hero-banner.png" alt="" />
    </div>

    <div id="contact">
      <div class="container">
        <div class="row mb-4">
          <div class="col-12">
            <h1>Contact Us</h1>
            <p>
              Lorem ipsum dolor sit amet, solum dictas vim cu, ne his hendrerit
              deterruisset, id sed doctus fuisset intellegam. Per case melius
              assentior ea. Et scaevola insolens eum. Ad vix verear eruditi
              ncillae, fabulas assentior his at, eum no dico euripidis
              prehendunt. Cibo delectus eu ius, usu veri putent at.
            </p>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="contact-map">
              <iframe
                width="100%"
                height="350"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                src="https://www.openstreetmap.org/export/embed.html?level=6&amp;bbox=-80.90731143951417%2C35.75420942888377%2C-80.87817192077637%2C35.797000464123876&amp;layer=mapnik&amp;marker=35.77560782504611%2C-80.89274168014526"
                style="border: none;"
              ></iframe
              ><br /><small
                ><a
                  href="https://www.openstreetmap.org/?mlat=35.7756&amp;mlon=-80.8927#map=15/35.7756/-80.8927"
                  >View Larger Map</a
                ></small
              >
            </div>
          </div>
        </div>

        <div class="row mb-5">
          <div class="col-12">
            <div id="contact-info">
              <div class="row">
                <div class="col-lg-3 mb-4 mb-lg-0">
                  <div class="heading">Address</div>
                  <p>J. C. Steele & Sons, Inc.</p>
                  <p>710 South Mulberry Street</p>
                  <p>Statesville, NC 28677 USA</p>
                </div>
                <div class="col-lg-2 mb-4 mb-lg-0">
                  <div class="heading">Phone</div>
                  <p>+1 704-872-3681</p>
                </div>
                <div class="col-lg-2 mb-4 mb-lg-0">
                  <div class="heading">Fax</div>
                  <p>+1 704-878-0789</p>
                </div>
                <div class="col-lg-2 mb-4 mb-lg-0">
                  <div class="heading">24-Hour Pager</div>
                  <p>704–832–0455</p>
                </div>
                <div class="col-lg-3">
                  <div class="heading">Email</div>
                  <p>info@jcsteele.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <h2>Content Block H2</h2>
            <p>
              Lorem ipsum dolor sit amet, solum dictas vim cu, ne his hendrerit
              deterruisset, id sed doctus fuisset intellegam. Per case melius
              assentior ea. Et scaevola insolens eum. Ad vix verear eruditi
              ncillae, fabulas assentior his at, eum no dico euripidis
              prehendunt. Cibo delectus eu ius, usu veri putent at.
            </p>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="successMessage" class="border-success" v-if="success">
              Thank you for submitting the form. We will be in contact with you
              shortly.
            </div>
            <b-form
              id="contact-form"
              @submit.prevent="submitContact"
              v-bind:class="{ error: error }"
              v-if="!success"
            >
              <div class="row mb-4">
                <div class="col-lg-6 mb-4 mb-lg-0">
                  <label for="name">Name</label>
                  <b-form-input id="name" v-model="name"></b-form-input>
                </div>
                <div class="col-lg-6">
                  <label for="companyName">Company Name</label>
                  <b-form-input
                    id="companyName"
                    v-model="companyName"
                  ></b-form-input>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-lg-6 mb-4 mb-lg-0">
                  <label for="Email">Email</label>
                  <b-form-input id="email" v-model="email"></b-form-input>
                </div>
                <div class="col-lg-6">
                  <label for="Phone">Phone</label>
                  <b-form-input id="phone" v-model="phone"></b-form-input>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-12">
                  <label for="Subject">Subject</label>
                  <b-form-input id="subject" v-model="subject"></b-form-input>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-12">
                  <label for="Message">Message</label>
                  <textarea id="message" v-model="message"></textarea>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3">
                  <button class="btn btn-primary" type="submit">
                    Submit Message
                  </button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FeApiService from "@/assets/js/FeApiService";
const apiService = new FeApiService();
export default {
  data() {
    return {
      name: "",
      companyName: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
      error: false,
      loader: this.loader,
      success: false
    };
  },
  computed: {},
  methods: {
    submitContact() {
      this.loader = true;
      apiService
        .postContact({
          name: this.name,
          companyName: this.companyName,
          email: this.email,
          phone: this.phone,
          subject: this.subject,
          message: this.message
        })
        .then(request => {
          this.contactSuccessful(request);
        })
        .catch(err => this.contactFailed(err));
    },
    contactSuccessful(req) {
      // if (!req.token) {
      //   this.contactFailed();
      //   return;
      // }
      // this.loader = false;
      // this.error = false;
      // this.success = true;
      localStorage.token = req.token;
      // this.$store.dispatch("contact");
      // this.$router.replace(this.$route.query.redirect || "/admin/index");
    },
    contactFailed(err) {
      // this.loader = false;
      // this.error = "Login failed!";
      // this.$store.dispatch("logout");
      // delete localStorage.token;
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
                title: err.error.response.data.title,
                autoHideDelay: 10000,
                appendToast: false,
                variant: "danger",
                solid: true
            });
    }
  }
};
</script>
